import React, { useState } from 'react';

const MicIcon = ({ active }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={active ? 'text-teal-300' : 'text-slate-400'}>
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <line x1="12" y1="19" x2="12" y2="23" />
    </svg>
);

const CameraIcon = ({ active }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={active ? 'text-teal-300' : 'text-slate-400'}>
        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
        <circle cx="12" cy="13" r="4" />
    </svg>
);

const TypeIcon = ({ active }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={active ? 'text-teal-300' : 'text-slate-400'}>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
);

const TABS = [
    {
        id: 'listen',
        label: 'Listen',
        desc: 'Lecture audio, video, voice',
        Icon: MicIcon,
        matches: (v) => v === 'live' || v === 'upload',
    },
    {
        id: 'photo',
        label: 'Upload',
        desc: 'Photo, PDF, Word, PowerPoint, Excel',
        Icon: CameraIcon,
        matches: (v) => v === 'image',
        value: 'image',
    },
    {
        id: 'type',
        label: 'Paste',
        desc: 'Paste or type your content',
        Icon: TypeIcon,
        matches: (v) => v === 'notes',
        value: 'notes',
    },
];

const ClinicalInputTypeSelector = ({ value, onChange }) => {
    const [listenSub, setListenSub] = useState('live');

    const activeTabId = TABS.find(t => t.matches(value))?.id ?? 'type';

    const handleTabClick = (tab) => {
        if (tab.id === 'listen') {
            onChange(listenSub);
        } else {
            onChange(tab.value);
        }
    };

    const handleListenSub = (sub) => {
        setListenSub(sub);
        onChange(sub);
    };

    return (
        <div>
            <div className="grid grid-cols-3 gap-2 sm:gap-3">
                {TABS.map((tab) => {
                    const active = activeTabId === tab.id;
                    return (
                        <button
                            key={tab.id}
                            type="button"
                            onClick={() => handleTabClick(tab)}
                            className={`flex flex-col items-center justify-center gap-1.5 rounded-2xl border py-4 sm:py-5 px-2 transition-all min-h-[72px] ${
                                active
                                    ? 'border-teal-500/50 bg-teal-500/8 ring-1 ring-teal-500/20'
                                    : 'border-white/8 bg-white/3 hover:bg-white/6 hover:border-white/15'
                            }`}
                        >
                            <tab.Icon active={active} />
                            <span className={`text-sm font-semibold leading-none ${active ? 'text-teal-200' : 'text-white'}`}>
                                {tab.label}
                            </span>
                            <span className="text-[11px] text-slate-500 leading-tight text-center hidden sm:block">
                                {tab.desc}
                            </span>
                        </button>
                    );
                })}
            </div>

            {activeTabId === 'listen' && (
                <div className="mt-3 flex gap-2">
                    {[
                        { id: 'live', label: '🎙 Live recording' },
                        { id: 'upload', label: '📁 Upload file' },
                    ].map((sub) => (
                        <button
                            key={sub.id}
                            type="button"
                            onClick={() => handleListenSub(sub.id)}
                            className={`flex-1 rounded-xl py-2 text-xs font-medium transition border ${
                                listenSub === sub.id
                                    ? 'border-teal-500/40 bg-teal-500/12 text-teal-300'
                                    : 'border-white/8 bg-white/3 text-slate-400 hover:text-slate-200 hover:border-white/15'
                            }`}
                        >
                            {sub.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ClinicalInputTypeSelector;
